
<template>
    <section class="banner-outer" style="text-align: center;">
        <div class="col-sm-12 col-md-12">
            <img src="https://img.hogonmr.cn/about-top.png?imageView2/0/w/1500" alt="">
        </div>
    </section>
<!--    <div class="inner-header" style="background: rgba(0, 0, 0, 0) url(https://img.hogonmr.cn/about-top.png?imageView2/0/w/1500) no-repeat scroll 0 0 / cover;padding-bottom: 170px;">-->
<!--        <h2></h2>-->
<!--    </div>-->
    <section class="blog">
        <!-- .blog -->
        <div class="container">
            <div class="col-sm-12 col-md-12 blog-deatails" style="font-size: 20px;">
                <p>{{test}}</p>
                <p class="hank text-left strong"><strong style="font-size:24px;">意大利时尚品牌 HOGON MR</strong></p>
                <p class="hank text-left strong">HOGON MR 1990发源于意大利，创立于2019·年的广州轻奢服饰鞋履品牌。HOGON MR随性别致的独特理念是对时尚生活方式的诠释。专为都市生活而打造轻奢个性服饰鞋履 ，将具功能性的实用元素与慵懒的优雅风格巧妙融合。以精致的工艺凸显非凡的品质</p>

                <img class="blog-img2" src="https://img.hogonmr.cn/about.png?imageView2/0/w/1500" alt="gallery1" />

                <p class="hank text-left strong"><strong style="font-size:24px;">品牌简介</strong></p>
                <p class="hank text-left strong">HOGON MR 1990年起始于意大利 2019年成立广州HOGON MR 创始人霍根先生 随性别致的独特理念是对时尚生活方式的完美诠释。</p>
                <br />

                <p class="hank text-left strong"><strong style="font-size:24px;">设计风格</strong></p>
                <p class="hank text-left strong">专为都市生活而打造轻奢个性服饰鞋履 ，将具功能性的实用元素与慵懒的优雅风格巧妙融合。以精致的工艺凸显非凡的品质</p>
                <br />

                <p class="hank text-left strong"><strong style="font-size:24px;">品牌文化</strong></p>
                <p class="hank text-left strong">创始人霍根先生（hogon mr ）以纯粹创新的设计为特色，HOGON MR对休闲奢华的风格诠释独特具革新的意义 ，讲求质地与制造完美呈现出时下的现代生活方式吸引了新时代追求时尚的消费者目光，致力于打造国际知名轻奢品牌。</p>
                <br />

                <p class="hank text-left strong"><strong style="font-size:24px;">品牌历程</strong></p>
                <p class="hank text-left strong">1993年5月，意大利米兰 第一家HOGON MR专卖店。</p>
                <p class="hank text-left strong">1998年秋冬，巴黎，第一家HOGON MR海外专卖店。</p>
                <p class="hank text-left strong">2007年9月，沙特，第一家中东地区HOGON MR专卖店</p>
                <p class="hank text-left strong">2013年，广州荔湾区1000平米品牌旗舰店正式开业</p>
                <p class="hank text-left strong">2020年11月，参加德国DOSELDUF时装展，发布2012秋冬新品。</p>
                <p class="hank text-left strong">2020年7月，印度尼西亚sogo百货，开设4家HOGON MR专卖店</p>
                <p class="hank text-left strong">2021年9月，参加意大利米兰buybrand展，展会唯一中国品牌，并发布2021秋冬流行趋势</p>
                <p class="hank text-left strong">2021年5月，HOGON MR品牌3周年暨冬季新品发布。</p>
                <p class="hank text-left strong">2021年12月 HOGON MR 品牌正式入驻抖音线上平台深受消费者追捧. </p>


                <div class="row">
                    <div class="col-lg-6">
                        <img class="blog-img2" src="https://img.hogonmr.cn/about1.png?imageView2/0/w/750" alt="gallery1" />
                    </div>
                    <div class="col-lg-6">
                        <img class="blog-img2" src="https://img.hogonmr.cn/about2.png?imageView2/0/w/750" alt="gallery1" />
                    </div>
                </div>



                <p class="hank text-left strong"><strong style="font-size:24px;">品牌理念</strong></p>
                <p class="hank text-left strong">不被定义，做你自己 品牌愿景致力于每位走进HOGON MR 的 女士 男士 都可以找到专属服饰</p>
                <br />
                <p class="hank text-left strong"><strong style="font-size:24px;">品牌画像</strong></p>
                <p class="hank text-left strong">独立、坚韧、乐观、积极、善良且温暖。充满正能量。</p>
                <br />
                <p class="hank text-left strong"><strong style="font-size:24px;">品牌定位</strong></p>
                <p class="hank text-left strong">HOGON MR专注于引领潮流高街时尚 </p>
                <br />
                <p class="hank text-left strong"><strong style="font-size:24px;">品牌愿景</strong></p>
                <p class="hank text-left strong">致力于每位走进HOGON MR 的消费者都可以找到专属服饰。</p>
                <br />
                <p class="hank text-left strong"><strong style="font-size:24px;">品牌风格</strong></p>
                <p class="hank text-left strong">创新、精致与多变 每一件 HOGONMR 时尚用品均选用上好材质精心打造，堪为真正的奢华创作。</p>
                <br />

            </div>
            <!-- /.blog -->
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
        }
    }
}

</script>

<style>

</style>
